import { NgModule } from '@angular/core';

import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { TranslationIdMap } from '../coaching-observation.i18n';

import { ObservationStatusComponent } from './observation-status.component';

@NgModule({
    imports: [CmpsLazyI18nModule.forChild(TranslationIdMap)],
    declarations: [ObservationStatusComponent],
    exports: [ObservationStatusComponent],
})
export class CmpsObservationStatusModule {}
